module.exports = "<div class=\"reveal\"><div class=\"slides\"><section data-state=\"title\"><h1>Kotlin</h1><h2>JVM Superpowers</h2></section><section *ngFor=\"let slideDeck of slides;\"><section *ngFor=\"let slide of slideDeck\"><dynamic-html [content]=\"slide\"></dynamic-html></section></section><section data-state=\"title\"><h1>Thanks!</h1><span class=\"inline\"><h2>Mike Plummer</h2><h4>@plummer_mike</h4></span><p>https://www.github.com/mike-plummer/intro-to-kotlin</p></section></div></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/slide-deck/slide-deck.component.pug
// module id = 314
// module chunks = 1